import Epg from 'services/epg'

const state = {
  communityId: 8,
  languageId: 3,
  tvCategories: [],
  radioCategories: [],
  selectedTvCategory: {},
  selectedRadioCategory: {},
  tvChannels: [],
  selectedChannel: {},
  radioChannels: [],
  currentEpg: [],
  events: [],
  currentEvent: {},
  favoritesVisible: false,
  nowTime: 0,
  epgForList: [],
  channelForEpg: {},
  calendarDay: '',
  calendarScrollToSelector: '.live-event',
  loaderVisible: false
}

const getters = {
  favoriteChannelsTv: (state) => {
    return state.tvChannels.filter((channel) => {
      return channel.categories.filter((category) => {
        return category.id === state.selectedTvCategory.id
      }).length > 0
    })
  },
  favoriteChannelsRadio: (state) => {
    return state.radioChannels.filter((channel) => {
      return channel.categories.filter((category) => {
        return category.id === state.selectedRadioCategory.id
      }).length > 0
    })
  },
  nowTime: state => state.nowTime
}

const mutations = {
  UPDATE_COMMUNITY_ID: (state, communityId) => {
    state.communityId = Object.freeze(communityId)
  },
  UPDATE_LANGUAGE_ID: (state, languageId) => {
    state.languageId = Object.freeze(languageId)
  },
  UPDATE_TV_CATEGORIES: (state, cats) => {
    state.tvCategories = Object.freeze(cats)
  },
  UPDATE_RADIO_CATEGORIES: (state, cats) => {
    state.radioCategories = Object.freeze(cats)
  },
  UPDATE_SELECTED_TV_CATEGORY: (state, categoryTv) => {
    state.selectedTvCategory = Object.freeze(categoryTv)
  },
  UPDATE_SELECTED_RADIO_CATEGORY: (state, categoryRadio) => {
    state.selectedRadioCategory = Object.freeze(categoryRadio)
  },
  UPDATE_TV_CHANNELS: (state, tvChannels) => {
    state.tvChannels = Object.freeze(tvChannels)
  },
  UPDATE_RADIO_CHANNELS: (state, radioChannels) => {
    state.radioChannels = Object.freeze(radioChannels)
  },
  UPDATE_CURRENT_EPG: (state, epg) => {
    state.currentEpg = Object.freeze(epg)
  },
  UPDATE_EPG_FOR_LIST: (state) => {
    state.epgForList = state.currentEpg
  },
  UPDATE_EVENTS: (state, events) => {
    state.events = Object.freeze(events)
  },
  UPDATE_CURRENT_EVENT: (state, event) => {
    state.currentEvent = Object.freeze(event)
  },
  TOGGLE_FAVORITE_SIDEBAR: (state) => {
    state.favoritesVisible = !state.favoritesVisible
  },
  UPDATE_NOW_TIME: (state) => {
    state.nowTime = Date.now()
  },
  UPDATE_SELECTED_CHANNEL: (state, channel) => {
    state.selectedChannel = channel
  },
  UPDATE_CHANNEL_FOR_EPG: (state, channel) => {
    state.channelForEpg = state.selectedChannel
  },
  UPDATE_CALENDAR_DAY: (state, calendarDay) => {
    state.calendarDay = calendarDay
  },
  TRIGGER_CALENDAR_SCROLL: (state, calendarScrollToSelector) => {
    state.calendarScrollToSelector = calendarScrollToSelector
  },
  UPDATE_IS_LOADING: (state, flag) => {
    state.loaderVisible = flag
  }
}

const actions = {
  async getTvCategories ({dispatch, commit, state}) {
    let payloadForPush = {
      communityId: state.communityId,
      languageId: state.languageId
    }

    try {
      let response = await Epg.getTvCategories(payloadForPush)
      // console.log('getTvCategories action...', response.data)
      commit('UPDATE_TV_CATEGORIES', response.data)
    } catch (error) {
      console.log('getTvCategories error...', error.response)
    }
  },

  async getRadioCategories ({dispatch, commit, state}) {
    let payloadForPush = {
      communityId: state.communityId,
      languageId: state.languageId
    }

    try {
      let response = await Epg.getRadioCategories(payloadForPush)
      // console.log('getRadioCategories action...', response.data)
      commit('UPDATE_RADIO_CATEGORIES', response.data)
    } catch (error) {
      console.log('getRadioCategories error...', error.response)
    }
  },

  async getTvChannels ({dispatch, commit, state}, payload) {
    let payloadForPush = {
      communityId: state.communityId,
      languageId: state.languageId,
      ...payload
    }

    try {
      let response = await Epg.getTvChannels(payloadForPush)
      // console.log('getTvChannels action...', response.data)
      commit('UPDATE_TV_CHANNELS', response.data)
    } catch (error) {
      console.log('getTvChannels error...', error.response)
    }
  },

  async getRadioChannels ({dispatch, commit, state}, payload) {
    let payloadForPush = {
      communityId: state.communityId,
      languageId: state.languageId,
      ...payload
    }

    try {
      let response = await Epg.getRadioChannels(payloadForPush)
      console.log('getRadioChannels action...', response.data)
      commit('UPDATE_RADIO_CHANNELS', response.data)
    } catch (error) {
      console.log('getRadioChannels error...', error.response)
    }
  },

  async getEpg ({dispatch, commit, state}, payload) {
    let payloadForPush = {
      communityId: state.communityId,
      languageId: state.languageId,
      ...payload
    }

    try {
      let response = await Epg.getEpg(payloadForPush)
      // console.log('getEpg action...', response.data[payloadForPush.cid])
      commit('UPDATE_CURRENT_EPG', response.data[payloadForPush.cid])
    } catch (error) {
      console.log('getEpg error...', error.response)
    }
  },

  async getEvents ({dispatch, commit, state}, payload) {
    let payloadForPush = {
      communityId: state.communityId,
      languageId: state.languageId,
      ...payload
    }

    try {
      let response = await Epg.getEvents(payloadForPush)
      console.log('getEvents action...', response.data)
      commit('UPDATE_EVENTS', response.data)
    } catch (error) {
      console.log('getEvents error...', error.response)
    }
  },

  async getEvent ({dispatch, commit, state}, eventId) {
    let payloadForPush = {
      communityId: state.communityId,
      languageId: state.languageId
    }

    try {
      let response = await Epg.getEvent(eventId, payloadForPush)
      console.log('getEvent action...', response.data)
      commit('UPDATE_CURRENT_EVENT', response.data)
    } catch (error) {
      console.log('getEvent error...', error.response)
    }
  },

  selectChannel ({dispatch, commit}, channel) {
    // console.log('channel.id', channel)
    commit('UPDATE_SELECTED_CHANNEL', channel)
    dispatch('getEpg', {
      cid: channel.id
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/guide.js